import {motion} from 'framer-motion';
import {useLandingImages} from '../landing/LandingImageContext';

function Hero() {
  const images = useLandingImages();
  return (
    <section className="hero" id="home">
      <img className="hero-image" src={images.hero} alt="Woman wearing an elegant gold ZEVI saree" />
      <div className="hero-shade" />
      <motion.div
        className="hero-content"
        initial={{opacity: 0, y: 24}}
        animate={{opacity: 1, y: 0}}
        transition={{duration: 0.9}}
      >
        <span className="eyebrow">ZEVI</span>
        <h1>Elegance that<br />Never Fades</h1>
        <p>Discover the art of timeless saree elegance with ZEVI.</p>
        <div className="button-row">
          <a className="gold-button" href="#collection">
            Explore collection
          </a>
          <a className="text-button" href="#collection">
            Shop now <span>→</span>
          </a>
        </div>
      </motion.div>
      <p className="hero-note">
        Sri Lankan<br />Sarees of<br />Timeless Beauty
      </p>
    </section>
  );
}

export default Hero;